<template>
  <Modal title="שינוי סיסמה" @close="$emit('close')">
    <div class="row">
      <div class="col-md-6">
        <form
          class="entry-block__form form pt-4 pb-8"
          @submit.prevent="resetPassword"
        >
          <div class="form__body mb-xl">
            <div class="entry-block__form-header">
              <h2 class="entry-block__form__title">שינוי סיסמה</h2>
              <div class="entry-block__form-text">
                <p>הכנס/י את סיסמתך החדשה ולחץ/י על ״שמור״</p>
              </div>
            </div>
            <Notice
              v-if="credentials.password && !$v.credentials.password.valid"
              text="
                    הסיסמה צריכה להכיל לפחות אות גדולה אחת, אות קטנה אחת, מספר אחד ותו מיוחד
                    אחד (!?.@#$%^&*()-+/{},)
                  "
            />
            <div class="form__field">
              <div class="form__field-label">סיסמה החדשה</div>
              <div
                class="form__field-password-btn"
                :class="{
                  'form__field-password-btn-big': recommendedType === 'success'
                }"
              >
                <div @click="password_type = !password_type">
                  <icon name="user-pass-see-icon" width="16" height="16" />
                </div>
                <div class="success-icon" v-if="recommendedType === 'success'">
                  <icon name="success" width="16" height="16" />
                </div>
              </div>
              <input
                @input="recommendedPassword(credentials.password)"
                v-model="credentials.password"
                :type="password_type ? 'password' : 'text'"
                :class="['form__field-input', { error: isDisabled }]"
                placeholder="סיסמה חדשה"
              />
              <div class="form__field-error">
                <span v-if="!$v.credentials.password.required">הזן סיסמה</span>
                <span
                  v-else-if="
                    credentials.password && !$v.credentials.password.minLength
                  "
                >
                  הסיסמה חייבת להיות לפחות 8 תווים
                </span>
                <span
                  v-else-if="
                    credentials.password && !$v.credentials.password.maxLength
                  "
                  >הסיסמה חייבת להיות עד 20 תווים</span
                >
              </div>
            </div>
            <recommended-password
              :recommended="recommended"
              :recommendedText="recommendedText"
              :recommendedType="recommendedType"
              :recommendedPasswordCount="recommendedPasswordCount"
              withoutList
            />

            <div class="d-md-none">
              <recommended-password
                :recommended="recommended"
                :recommendedText="recommendedText"
                :recommendedType="recommendedType"
                :recommendedPasswordCount="recommendedPasswordCount"
                withoutDots
              />
            </div>

            <div class="form__field">
              <div class="form__field-label">אימות סיסמה</div>
              <div
                class="form__field-password-btn"
                @click="confirmPassword_type = !confirmPassword_type"
              >
                <icon name="user-pass-see-icon" width="16" height="16" />
              </div>

              <input
                v-model="credentials.password_confirmation"
                :type="confirmPassword_type ? 'password' : 'text'"
                :class="['form__field-input', { error: isDisabled }]"
                placeholder="אימות סיסמה"
              />
              <div class="form__field-error">
                <span v-if="!$v.credentials.password_confirmation.required"
                  >נדרש אימות סיסמה</span
                >
                <span
                  v-else-if="
                    credentials.password_confirmation &&
                    !$v.credentials.password_confirmation.sameAsPassword
                  "
                  >הסיסמה שהוזנה צריכה ליהיות זהה לאימות הסיסמה</span
                >
              </div>
            </div>
          </div>
          <div class="send-message_block">
            <span>לשלוח למשתמש פרטי כניסה לאזור האישי</span>
            <CheckBoxModalVue
              :check="sendMessage"
              @checkedElem="checkedElem"
            ></CheckBoxModalVue>
          </div>
          <div class="form__footer">
            <div class="row">
              <div class="col-6">
                <router-link
                  to=""
                  @click.native="$emit('close')"
                  class="btn btn--border-grey w-100"
                >
                  בטל
                </router-link>
              </div>
              <div class="col-6">
                <button
                  class="btn btn--blue w-100"
                  :disabled="isDisabled"
                  @click.prevent="resetPassword"
                >
                  שמור
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-6 d-none d-md-block">
        <recommended-password
          :recommended="recommended"
          :recommendedText="recommendedText"
          :recommendedType="recommendedType"
          :recommendedPasswordCount="recommendedPasswordCount"
          withoutDots
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/Components/UI/Modal';
import recommendedPassword from '@/mixins/recommendedPassword';
import {
  maxLength,
  minLength,
  required,
  sameAs
} from 'vuelidate/lib/validators';
import axios from 'axios';
import CheckBoxModalVue from '@/Components/UI/Form/CheckBoxModal.vue';

export default {
  name: 'StudentChangePassword',
  components: {
    Modal,
    CheckBoxModalVue
  },
  mixins: [recommendedPassword],
  props: {
    user: Object
  },
  data() {
    return {
      errors: {},
      sendMessage: false,
      credentials: {
        email: '',
        token: '',
        password: '',
        password_confirmation: ''
      },
      password_type: true,
      confirmPassword_type: true
    };
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid;
    }
  },
  validations: {
    credentials: {
      password: {
        required,
        valid(value) {
          const containsUppercase = /[A-Z]/.test(value);
          const containsLowercase = /[a-z]/.test(value);
          const containsNumber = /[0-9]/.test(value);
          const containsSpecial = /[.*+?^${}!@#%&_:<>()|/\-[\]\\,]/.test(value);
          return (
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecial
          );
        },
        minLength: minLength(8),
        maxLength: maxLength(20)
      },
      password_confirmation: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  mounted() {
    this.getToken();
  },
  methods: {
    async sendMessageLogin(user) {
      try {
        const respons = await axios.post('/api/send-updated-user-credentials', {
          user_id: this.user.id,
          password: this.credentials.password
        });
      } catch (error) {
        console.log(error);
      }
    },
    checkedElem() {
      this.sendMessage = !this.sendMessage;
    },
    getToken() {
      axios.post(`/api/user/${this.user.id}/reset-token`).then(res => {
        this.credentials.token = res.data;
      });
    },
    resetPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.recommended.passwordError = false;
      this.errors = {};
      this.credentials.email = this.user.email;

      axios
        .post(`/api/user/${this.user.id}/reset-password`, this.credentials)
        .then(res => {
          this.$emit('close');
          if (this.sendMessage) {
            this.sendMessageLogin();
          }
          this.$toastr.s('נשמר');
        })
        .catch(err => {
          this.errors = err?.response?.data?.errors || {};
          this.recommended.passwordError =
            Array.isArray(this.errors.password) &&
            this.errors.password.length > 0;
          const firstPasswordError = Array.isArray(this.errors.password)
            ? this.errors.password[0]
            : null;
          if (firstPasswordError) {
            this.$toastr.e(firstPasswordError);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.send-message_block {
  width: 100%;
  height: 64px;
  // padding: 16px 16px 24px 16px;
  display: flex;
  gap: 8px;
  flex-direction: row-reverse;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
}

.error-notice {
  display: none !important;
}

.form__field-input {
  direction: ltr;
  text-align: right;
}
</style>
